import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_dialog_actions = _resolveComponent("ontos-dialog-actions")!
  const _component_ontos_form_panel = _resolveComponent("ontos-form-panel")!
  const _component_ontos_dialog = _resolveComponent("ontos-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_dialog, {
    "model-value": true,
    fullscreen: _ctx.$vuetify.display.smAndDown,
    "max-width": _ctx.maxWidth,
    persistent: _ctx.loaded,
    "onUpdate:modelValue": _ctx.onDialogInput
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ontos_form_panel, {
        title: _ctx.title,
        subtitle: _ctx.subtitle,
        accent: _ctx.accent,
        loaded: _ctx.loaded,
        saving: _ctx.saving,
        "save-disabled": _ctx.saveDisabled,
        onSave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save')))
      }, {
        controls: _withCtx(() => [
          _createVNode(_component_ontos_dialog_actions, {
            "full-page-route": _ctx.fullPageRoute,
            dirty: _ctx.dirty,
            disabled: _ctx.saving,
            onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
          }, null, 8, ["full-page-route", "dirty", "disabled"])
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["title", "subtitle", "accent", "loaded", "saving", "save-disabled"])
    ]),
    _: 3
  }, 8, ["fullscreen", "max-width", "persistent", "onUpdate:modelValue"]))
}